(function(){
  if(window.__chesterfieldComboReady)return;
  window.__chesterfieldComboReady=true;
  var NOTE='Sofá, poltronas e almofadas vão juntos para o carrinho.';
  function brl(cents){return new Intl.NumberFormat('pt-BR',{style:'currency',currency:'BRL'}).format(cents/100)}
  function note(root,text,isError){var el=root.querySelector('.ccx__note');if(!el)return;el.textContent=text;el.classList.toggle('is-error',!!isError)}
  function update(root,choice){
    if(!choice)return;
    root.querySelectorAll('.ccx__choice').forEach(function(b){b.setAttribute('aria-pressed',b===choice?'true':'false')});
    root.querySelector('.ccx__total').textContent=brl(Number(choice.dataset.price));
    var img=root.querySelector('.ccx__sofa-image');
    if(img&&choice.dataset.image&&img.src.indexOf(choice.dataset.image.split('?')[0])===-1){
      img.classList.add('is-swapping');
      img.onload=function(){img.classList.remove('is-swapping')};
      img.src=choice.dataset.image;
    }
    if(img)img.alt='Sofá Chesterfield '+root.dataset.color+' de '+choice.dataset.size;
  }
  function label(button,text){var t=button.querySelector('.ccx__cta-text');if(t)t.textContent=text}
  document.addEventListener('click',async function(event){
    var choice=event.target.closest('.ccx__choice');
    if(choice){if(!choice.disabled)update(choice.closest('.ccx'),choice);return}
    var button=event.target.closest('.ccx__cta');if(!button)return;
    var root=button.closest('.ccx'),chosen=root.querySelector('.ccx__choice[aria-pressed="true"]');
    if(!chosen)return;
    button.disabled=true;label(button,'Adicionando…');note(root,NOTE,false);
    try{
      var add=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:Number(chosen.dataset.variant),quantity:1},{id:Number(root.dataset.kit),quantity:1}]})});
      if(!add.ok)throw new Error('add');
      var drawer=document.querySelector('cart-drawer');
      if(!drawer||typeof drawer.renderContents!=='function'){window.location.href='/cart';return}
      var sections=drawer.getSectionsToRender().map(function(s){return s.id});
      var refresh=await fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({sections:sections,sections_url:window.location.pathname})});
      if(!refresh.ok){window.location.href='/cart';return}
      var cart=await refresh.json();
      if(!cart.sections||!cart.sections['cart-drawer']){window.location.href='/cart';return}
      drawer.classList.remove('is-empty');
      drawer.renderContents(cart);
      note(root,'Conjunto adicionado ao carrinho.',false);
    }catch(error){
      note(root,'Não foi possível adicionar o conjunto agora. Tente de novo em instantes.',true);
    }finally{
      button.disabled=false;label(button,'Adquirir o conjunto');
    }
  });
})();
